import React from 'react';
import styled from 'styled-components';
import * as R from 'ramda';
import { Link } from 'gatsby';
import { color, typography } from 'styled-system';
import { themeGet } from '@styled-system/theme-get';
import { ApplyIcon, LoginIcon } from './Icons';
import { Box } from '@cowsquare/design';
import { getUserOptions, clickUserOption } from './userOptions';
import { COWSQUARE_APP_URL, ORG_ID } from '../../../constants';
import { isBrowser } from '../../../utils/isBrowser';

const Menu = styled.div`
  border-top: 1px solid #e5e5e5;
  border-bottom: 1px solid #e5e5e5;
`;

const MobileMenuItem = styled(Link)`
  display: flex;
  align-items: center;
  color: ${themeGet('colors.blacks.6')};
  ${color}
  ${typography}
  text-decoration: none;
  font-size: 14px;
  height: 60px;
  line-height: 60px;
  padding-left: 16px;
  cursor: pointer;

  &.active {
    border-left: 4px solid ${themeGet('colors.primary')};
  }
`;

export const MobileMenu = ({ menu = [], closeMenu = R.identity }) => (
  <Menu>
    {R.map(item => (
      <MobileMenuItem
        activeClassName="active"
        partiallyActive
        key={item.link}
        to={item.link}
        onClick={closeMenu}
      >
        {item.name}
      </MobileMenuItem>
    ))(menu)}
  </Menu>
);

export const MobileUser = ({ user, closeMenu }) => {
  return (
    isBrowser &&
    (user ? (
      <>
        <MobileMenuItem as="span" color="blacks.0" fontWeight="600">
          {user.name}
        </MobileMenuItem>
        {R.map(
          option => (
            <MobileMenuItem
              as="span"
              key={option.value}
              onClick={() => {
                closeMenu();
                clickUserOption(option);
              }}
            >
              {option.icon}
              <Box ml="16px">{option.name}</Box>
            </MobileMenuItem>
          ),
          getUserOptions(user)
        )}
      </>
    ) : (
      <>
        <MobileMenuItem onClick={closeMenu} to="/public/apply">
          <ApplyIcon />
          <Box ml="16px">Apply</Box>
        </MobileMenuItem>
        <MobileMenuItem
          as="a"
          href={`${COWSQUARE_APP_URL}/user/login?redirect=${encodeURIComponent(
            window.location.href
          )}&orgId=${ORG_ID}`}
        >
          <LoginIcon />
          <Box ml="16px">Login</Box>
        </MobileMenuItem>
      </>
    ))
  );
};
